// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module--header--31rfm","button":"style-module--button--3vNNw","inverted":"style-module--inverted--3YUlm"};